export const finiteOr = (value: number, fallback: number) =>
  Number.isFinite(value) ? value : fallback;